module.exports = __webpack_public_path__ + "img/play_color.7ec609e9.svg";